Vue.component('form-component', {
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    data: function () {
        return {
            hasCaptcha: false,
            captchaExecuted: false
        }
    },
    methods: {
        submit: function () {
            this.$validator.validateAll().then(result => {
                let form = this.$el;

                if (result) {
                    if (!this.hasCaptcha || this.captchaExecuted) {
                        this.$root.submitForm(form);
                    } else {
                        this.$refs.recaptcha.execute();
                    }
                } else if (result) {
                    this.$root.submitForm(form);
                }
            });
        },
        onCaptchaVerified: function () {
            this.captchaExecuted = true;
            this.submit();
        }
    },
});
